import { So5LeaderboardType, Sport } from '__generated__/globalTypes';
import { CommunityBlock } from 'components/landing/CommunityBlock';

export const Community = () => {
  return (
    <CommunityBlock
      leaderboards={[
        {
          sport: Sport.FOOTBALL,
          leaderboardType: So5LeaderboardType.GLOBAL_CAP_270_UNIQUE,
        },
        {
          sport: Sport.NBA,
          leaderboardType: So5LeaderboardType.NBA_LIMITED_CONTENDER,
        },
        {
          sport: Sport.BASEBALL,
          leaderboardType: So5LeaderboardType.MLB_RARE_ALL_STAR,
        },
      ]}
    />
  );
};
